import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=5dfba190&isFirst&isPage"
import script from "./index.mpx?vue&type=script&lang=ts&isFirst&isPage"
export * from "./index.mpx?vue&type=script&lang=ts&isFirst&isPage"
import style0 from "./index.mpx?vue&type=style&index=0&id=5dfba190&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_eed54686%22%7D&isFirst&isPage"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports